var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNpDial = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.206,
    height: 17.809,
    viewBox: "0 0 18.206 17.809",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_dial_940593_000000",
    transform: "translate(-5.214 -6.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M32.66,29.208a5.194,5.194,0,0,1-5.182,5.208,5.119,5.119,0,0,1-3.106-1.053L28,29.715A.717.717,0,0,0,28,28.7a.708.708,0,0,0-1.01,0l-3.648,3.647a5.192,5.192,0,1,1,9.316-3.14Z",
    transform: "translate(-13.148 -13.624)",
    fill: "#908b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M17.647,24.108a1,1,0,0,1-.9-.59.961.961,0,0,1,.509-1.282l.163-.081a.979.979,0,1,1,.834,1.771l-.2.081a.807.807,0,0,1-.407.1Zm5.413-5.781A.958.958,0,0,1,22,18.511a.971.971,0,0,1-.509-1.282l.061-.163a.975.975,0,0,1,1.262-.529.957.957,0,0,1,.529,1.262l-.081.2a.56.56,0,0,1-.2.327ZM10.645,23.946a1.1,1.1,0,0,1-.428-.1c-.061-.041-.142-.061-.2-.1a.975.975,0,1,1,.937-1.709l.142.081a.981.981,0,0,1,.448,1.3,1.085,1.085,0,0,1-.9.529ZM6.229,18.268a.976.976,0,0,1-.956-.774l-.041-.2a.974.974,0,0,1,1.914-.367l.041.183a.99.99,0,0,1-.753,1.16.7.7,0,0,0-.2,0Zm14.756-6.7a.992.992,0,0,1-.793-.407l-.1-.142a.971.971,0,1,1,1.526-1.2l.142.183a.975.975,0,0,1-.2,1.363.855.855,0,0,1-.57.2ZM7.918,11.266a.977.977,0,0,1-.611-.224.99.99,0,0,1-.142-1.363l.142-.163A.981.981,0,1,1,8.794,10.8l-.122.122a1.007,1.007,0,0,1-.753.346Zm6.716-3.032h-.223a.959.959,0,0,1-.956-.977.972.972,0,0,1,.977-.956h.224a.979.979,0,0,1,.937,1.018.964.964,0,0,1-.958.916Z",
    fill: "#908b96"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNpDial, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/np_dial.f60c34d1.svg";
export { ForwardRef as ReactComponent };